import { CT_GATE_KEYS } from './creature-type-gate';

// The page reader preserves provider walks and list-valued layers in compiled blobs.
declare function ftLayerHas(ability: unknown, key: string): boolean;

export function fixedSummonCreatureId(ability: unknown): string {
    if (!ability || !ftLayerHas(ability, 'summon')) return '';
    const entry = ftLayerValue(ability, 'summon');
    return (typeof entry === 'string' ? entry : String(ftItemsCol(entry, 'item_id') ?? '')).trim().toUpperCase();
}

/** Corpse transformations and creature-type-gated summons consume creature targets. */
export function usesGroundSummonPlacement(ability: unknown): boolean {
    if (!ability) return false;
    return !ftLayerHas(ability, 'summon_transforms_targeted_corpse')
        && !CT_GATE_KEYS.some(key => ftLayerHas(ability, key))
        && (fixedSummonCreatureId(ability) !== '' || ftLayerHas(ability, 'user_choice_1_summon'));
}
